import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import InputPromoItems from "../../components/commons/promo/InputPromoItems";

function PromoModal({ show, toggle, type, action, data, register }) {

    const title = type === "add" ? "Tambah Promo" : data.name

    return (
        <>
            <Modal isOpen={show} modalTransition={{ timeout: 700 }} backdropTransition={{ timeout: 1300 }}>
                <ModalHeader className="text-extra-bold pt-5"> {title} <span className="close clickable click-in-right" onClick={toggle}>&times;</span></ModalHeader>
                <p className="desc-title-form">Isi form berikut untuk mengedit promo</p>
                

                <ModalBody>
                    <InputPromoItems
                        action={action}
                        register={register}
                        data={data}
                        toggle={toggle}
                    />
                </ModalBody>
                <ModalFooter />
            </Modal>
        </>
    )
}

export default PromoModal
